import { Fragment, memo, MouseEventHandler, useReducer } from 'react';

import clsx from 'clsx';
import { Expand } from 'lucide-react';

import Dialog from '@mui/material/Dialog';

import css from './ImageButton.module.css';

import { WithClassName } from 'v2/types';

export interface ImageButtonProps extends WithClassName {
  src: string;
  alt: string;
}

export const ImageButton = memo<ImageButtonProps>(({ className, src, alt }) => {
  const [isPreviewOpen, setPreviewOpen] = useReducer((state) => !state, false);

  const handleToggleDialog: MouseEventHandler = (e) => {
    e.stopPropagation();
    setPreviewOpen();
  };

  return (
    <Fragment>
      <button className={clsx(css.imageButton, className)} onClick={handleToggleDialog} type="button">
        <img className={css.imageButtonImg} src={src} alt={alt} />

        <div className={css.imageButtonExpand}>
          <Expand color="white" />
        </div>
      </button>

      <Dialog
        slotProps={{ paper: { className: css.imageButtonDialog } }}
        open={isPreviewOpen}
        onClose={handleToggleDialog}
      >
        <img className={css.imageButtonDialogImage} src={src} alt={alt} />
      </Dialog>
    </Fragment>
  );
});

ImageButton.displayName = 'ImageButton';
